import { Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';

import HairCoveringCace from './facecheck-hair-covering-face.svg';
import OtherPeopleVisible from './facecheck-other-people-visible.svg';
import PhotosWithPeopleVisible from './facecheck-photos-with-people-visible.svg';
import PoorLighting from './facecheck-poor-lighting.svg';
import WearingHatOrSunglasses from './facecheck-wearing-hat-sunglasses.svg';
import GuideItem, { TGuideItem } from './GuideItem';

const badItems: TGuideItem[] = [
  { icon: PoorLighting, label: 'Poor lighting' },
  { icon: HairCoveringCace, label: 'Hair covering face' },
  { icon: WearingHatOrSunglasses, label: 'Wearing hat or sunglasses' },
  { icon: OtherPeopleVisible, label: 'Other people visible' },
  { icon: PhotosWithPeopleVisible, label: 'Photos with people visible' },
];

export default function UnacceptedSection({ dataTestId }: Readonly<{ dataTestId: string }>) {
  return (
    <Stack gap={tokens.spacingBase} data-component="unaccepted-section" data-testid={dataTestId}>
      <Stack
        direction="row"
        gap={[tokens.spacingSm, tokens.spacingBase]}
        flexWrap="wrap"
        justifyContent="center"
      >
        {badItems.map((item) => (
          <GuideItem
            key={item.label}
            item={item}
            variant="compact"
            dataComponent="unaccepted-item"
            dataTestId={`${dataTestId}-${item.label.replace(/\s+/g, '-').toLowerCase()}`}
          />
        ))}
      </Stack>
      <Typography variant="body1" textAlign="center" data-component="unaccepted-description">
        Poor lighting, hats, glasses, or hair covering your face can cause facial recognition to
        fail. Ensure there are no other people or photos of people in the background.
      </Typography>
    </Stack>
  );
}
